var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuse-content-wrapper"},[_c('v-container',{staticClass:"text-center mt-5",attrs:{"fluid":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"#71BEC8","rounded":""},on:{"click":_vm.deleteCache}},[_vm._v(_vm._s(_vm.$t('delete caches')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }